import { createFileRoute } from "@tanstack/react-router";
import { OrganizationWageSetsPage } from "@/features/organization-wage-sets/components/organization-wage-sets-page";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/jobs/wage-sets/",
)({
  component: OrganizationWageSetsRoute,
});

function OrganizationWageSetsRoute() {
  const { user } = Route.useRouteContext();
  return <OrganizationWageSetsPage user={user} />;
}
